import NextLink from 'next/link'

import { Separator } from '@wartek-id/separator'
import { Text } from '@wartek-id/text'

import { useSETrackEvent } from 'app/ProfileRevampPage/hooks/useSETrackEvent'

type TProfileAksiNyataProps = React.HTMLAttributes<HTMLAnchorElement> & {
  index: number
  id: string
  title: string
  topicId: string
  topicName: string
}
const ListItem = ({
  index,
  id,
  title,
  topicId,
  topicName,
  ...props
}: TProfileAksiNyataProps) => {
  const link = `/pelatihan-mandiri/aksi-nyata/${id}?topik_name=${topicName}&topik_id=${topicId}`
  const { SETrackClickAksiNyataItem } = useSETrackEvent()

  const onClickItem = () => {
    SETrackClickAksiNyataItem({
      aksiNyataLocation: index + 1,
      aksiNyataId: id,
    })
  }

  return (
    <NextLink href={link} passHref>
      <a {...props} onClick={onClickItem}>
        <div className="mb-2 border border-subdued rounded-[4px] h-full">
          <div className="p-3">
            <Text variant="helper" className="line-clamp-3">
              Topik: {topicName}
            </Text>
          </div>
          <Separator />
          <div className="p-3">
            <Text variant="heading-sm" className="line-clamp-3">
              {title}
            </Text>
          </div>
        </div>
      </a>
    </NextLink>
  )
}

export default ListItem
